module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.449112c1.png";